import { cn } from "@theprelude/core";

export const GmailIcon: React.FC<React.ComponentPropsWithoutRef<"svg">> = ({
  className,
  ...props
}) => (
  <svg
    className={cn("size-4 flex-shrink-0", className)}
    {...props}
    viewBox="0 0 24 25"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M19 11.0105L24 7.27119V5.66781C24 3.64417 21.69 2.49053 20.0727 3.70417L19 4.50868V11.0105Z" />
    <path d="M19 12.2592V21.2132H22.3636C23.269 21.2132 24 20.4796 24 19.5769V8.51991L19 12.2592Z" />
    <path d="M0 7.26093L5 11.0003V4.50871L3.92727 3.70417C2.30727 2.49053 0 3.64417 0 5.66781V7.26093Z" />
    <path d="M0 8.50965L5 12.249V21.2132H1.63636C0.733636 21.2132 0 20.4823 0 19.5769V8.50965Z" />
    <path d="M18 5.25873L12 9.7587L6 5.25867V11.7481L12.4101 16.5421L18 12.3496V5.25873Z" />
  </svg>
);
